
export function verifyUserExists<T>(userLikes?: T | any, userId?: string | null): boolean {
  return (userLikes || []).some((user: string) => user.startsWith(userId?.slice(0, 7) || ''));
}
